export default __webpack_public_path__ + "static/ImitatiaOrig-e87cbfec37ad01b8e5a540fee7faa5ec.jpg";